import React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { CookiesProvider } from 'react-cookie';
import Contract from './components/Contract';
import PrivateRoute from './components/PrivateRoute';
import Routes from './routes';
import './App.css';
import { Global } from './styles/global';
import NotFound from './components/PageNotFound';
import TermOk from './components/Contract/components/TermOk';
import NotConnected from './components/NotConnected';

const App: React.FC = () => (
  <>
    <CookiesProvider>
      <Global />
      <BrowserRouter>
        <Switch>
          <Route path="/termok" exact component={TermOk} />
          <Route path="/notfound" exact component={NotFound} />
          <Route path="/notconnected" exact component={NotConnected} />
          <Route path="/term" exact component={Contract} />
          <PrivateRoute path="/" component={Routes} />
        </Switch>
      </BrowserRouter>
    </CookiesProvider>
  </>
);

export default App;
